module.exports = __webpack_public_path__ + "assets/media/day1.23ddd27d.mp3";